import React from "react";
import {ResetFinancesContainer} from "../../components/reset-finances/ResetFinancesContainer";

export const ResetFinancesView: React.FunctionComponent = () => {
  return <ResetFinancesContainer />;
};
